module.exports = __webpack_public_path__ + "img/btn-predict-and-win-thin.28605f26.png";